import { PageHeader } from 'antd';
import styled from 'styled-components';

export const Header = styled(PageHeader)`
  padding: 0 0 2rem 0;
`;
